/* @flow */
import * as React from 'react';

import ConfirmDialog from 'components/ConfirmDialog';
import ChatActions from 'chat/actions/ChatActions';
import Glyph from 'components/Glyph';
import Link from '../../components/Link';
import MenuItem from 'components/MenuItem';
import ModalMenuItem from 'components/ModalMenuItem';
import RelationshipActions from 'actions/RelationshipActions';

type Props = {
  memberId: number,
  memberName: string,
  blocked?: boolean,
  disabled?: boolean,
  chatUUID?: string,
};

export default class BlockMemberMenuItem extends React.Component<Props> {
  blockMember = (): void => {
    const { memberId, memberName, chatUUID } = this.props;
    // eslint-disable-next-line promise/catch-or-return
    RelationshipActions.block(memberId, memberName).then(() => {
      if (chatUUID) {
        ChatActions.loadChat(chatUUID);
      }
    });
  };

  unblockMember = (): void => {
    const { memberId, memberName, chatUUID } = this.props;
    // eslint-disable-next-line promise/catch-or-return
    RelationshipActions.unblock(memberId, memberName).then(() => {
      if (chatUUID) {
        ChatActions.loadChat(chatUUID);
      }
    });
  };

  renderConfirmDialog() {
    const { memberName } = this.props;
    return (
      <ConfirmDialog
        eventScreenName="BlockMemberMenuItem"
        actionButtonText="Block"
        cancelButtonText="Cancel"
        size="xsmall"
        onConfirm={this.blockMember}
        title={`Block ${memberName}?`}
        subtext={
          <React.Fragment>
            You will no longer be able to direct message or add them to your classes. They will
            still be able to join classes owned by you unless you{' '}
            <Link target="_blank" href="https://help.remind.com/hc/en-us/articles/202685535">
              change the class code.
            </Link>
          </React.Fragment>
        }
      />
    );
  }

  render() {
    if (this.props.blocked) {
      return (
        <MenuItem
          onClick={this.unblockMember}
          disabled={this.props.disabled}
          data-test-selector={`conversation-sidebar-participant-menu-unblock-${this.props.memberId}`}>
          <Glyph name="disabled" />
          <span>Unblock user</span>
        </MenuItem>
      );
    } else {
      return (
        <ModalMenuItem
          modal={this.renderConfirmDialog()}
          disabled={this.props.disabled}
          data-test-selector={`conversation-sidebar-participant-menu-block-${this.props.memberId}`}>
          <Glyph name="disabled" />
          <span>Block user</span>
        </ModalMenuItem>
      );
    }
  }
}
